import { type FC } from 'react';

import { type EwayAccessCode } from '@/api/registration/payment';
import { type CartDisplay } from '@/api/registration';
import EwayPaymentIframe from '@/registration/component/Register/Payment/PayByEWayIframe';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';

export interface PayByEWayProps {
  setErrors: React.Dispatch<React.SetStateAction<string[]>>
  options: EwayAccessCode
  cart: CartDisplay
  isValid: boolean
}

const PayByEWay: FC<PayByEWayProps> = ({
  setErrors,
  options,
  cart,
  isValid
}) => {
  const { toPaymentProcessingStep } = useRegisterGroupSteps();

  const resultCallback = async (result: string, transactionID: string, errors: string) => {
    if (errors) {
      setErrors([errors]);
    } else if (result === 'Complete') {
      // Whether a transaction was processed. One of Complete, Cancel, or Error
      const additionalParams = { orderHash: options.order.secureHash };
      toPaymentProcessingStep(additionalParams);
    }
  };

  return (
    <EwayPaymentIframe
      isLoading={false}
      isDisabled={!isValid}
      sharedPaymentUrl={options.accessCodesShared}
      resultCallback={resultCallback}
    />
  );
};

export default PayByEWay;
